import Box from '@mui/material/Box';

interface InitialsProps {
  firstName?: string | null;
  lastName?: string | null;
  sx?: object;
}

export default function Initials({ firstName, lastName, sx }: InitialsProps) {
  const initials = `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase() || '?';

  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.75rem',
        fontWeight: 600,
        flexShrink: 0,
        ...sx
      }}
    >
      {initials}
    </Box>
  );
}
